import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Footer from "components/Footer/Footer.jsx";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import routes from "routes.jsx";
import { connect } from 'react-redux';

class Pages extends React.Component {
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/admin/" } }
    if (this.props.loggedIn) {
      // console.log(this.props.location)
      // const { from } = this.props.location.state || { from: { pathname: '/' } }
      if(from && from.pathname === "/"){
        from.pathname = "/admin/"
      }
      return <Redirect to={from} />
    } else {
      if(this.props.loggedIn === false && from && from.pathname === "/admin/ask"){
        from.pathname = "/auth/ask";
        return <Redirect to={from} />
      }
    }
    return (
      <div>
        <div className="wrapper wrapper-full-page" ref="fullPages">
          <div className="full-page section-image">
            <Switch>{this.getRoutes(routes)}</Switch>
            <Footer fluid />
            <ToastContainer autoClose={8000} />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    loggedIn: state.login.loggedIn
  })
)(Pages);
